import { useI18n } from '../i18n/useI18n';
import { reportAssets } from '../data/websiteAssets';

const reportItems = [
  'report.item.summary',
  'report.item.level',
  'report.item.photo',
  'report.item.time',
  'report.item.signatures',
  'report.item.server',
  'report.item.warnings',
  'report.item.qr',
];

export function ReportSection() {
  const { language, t } = useI18n();
  const image = reportAssets.get(language);

  return (
    <section className="section report-section">
      <div>
        <p className="eyebrow">{t('report.eyebrow')}</p>
        <h2>{t('report.title')}</h2>
        <p>{t('report.text')}</p>
        <ul className="plain-list compact">
          {reportItems.map((item) => (
            <li key={item}>{t(item)}</li>
          ))}
        </ul>
        <p className="section-note">{t('report.note')}</p>
      </div>
      <picture className="section-visual report-visual">
        <source srcSet={image.webp} type="image/webp" />
        <img src={image.png} alt={t('report.preview')} loading="lazy" width="1484" height="1060" />
      </picture>
    </section>
  );
}
